import type { PathType } from './types';
import { getPath } from './types';

export const ticketPaths: { [key: string]: PathType } = {
  ticketType: getPath('/system-admin/ticket-type', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketType'
  ]),
  ticketCategoryGroup: getPath('/system-admin/ticket-category-group', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketCategoryGroup'
  ]),
  ticketCategory: getPath('/system-admin/ticket-category', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketCategory'
  ]),
  ticketCategoryEdit: getPath('/system-admin/ticket-category/edit', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketCategory',
    'action.edit'
  ]),
  ticketCategoryAdd: getPath('/system-admin/ticket-category/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketCategory',
    'action.add'
  ]),
  ticketCategoryDetail: getPath('/system-admin/ticket-category/detail', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketCategory',
    'page.detail'
  ]),
  ticketForm: getPath('/system-admin/ticket-form', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketForm'
  ]),
  ticketFormAdd: getPath('/system-admin/ticket-form/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketForm',
    'action.add'
  ]),
  ticketFormEdit: getPath('/system-admin/ticket-form/edit', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketForm',
    'action.edit'
  ]),
  ticketFormDetail: getPath('/system-admin/ticket-form/detail', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketForm',
    'page.detail'
  ]),
  ticketFormMapping: getPath('/system-admin/ticket-form-mapping', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.ticketFormMapping'
  ]),
  reason: getPath('/system-admin/reason', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'sidebar.ticket.reason'
  ])
};
